import React from "react";
import "./../styles/loader.css";

const FullScreenLoader = ({ loading }) => {
  return (
    <div
      id="WIP_loader"
      className={`lodr-overlay ${loading ? "show" : "hide"}`}
    >
      <div className="gif-loader">
        <img
          src="/images/loader.f24c91f2.svg"
          alt="Loading..."
          className="m-b-15"
        />
        <p>Please wait...</p>
      </div>
    </div>
  );
};

export default FullScreenLoader;
